import type { App } from 'vue'

export default function (app: App) {
    Date.prototype.toISOString = function () {
        var tzo = -this.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function (num: number) {
                return (num < 10 ? '0' : '') + num
            }

        return (
            this.getFullYear() +
            '-' +
            pad(this.getMonth() + 1) +
            '-' +
            pad(this.getDate()) +
            'T' +
            pad(this.getHours()) +
            ':' +
            pad(this.getMinutes()) +
            ':' +
            pad(this.getSeconds()) +
            dif +
            pad(Math.floor(Math.abs(tzo) / 60)) +
            pad(Math.abs(tzo) % 60)
        )
    }
}
